import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { createSafeContext } from "@components/mantine";
var ref = _sliced_to_array(createSafeContext("AccessTableContextProvider component was not found in the tree"), 2);
export var AccessTableContextProvider = ref[0], useAccessTableContext = ref[1];

//# sourceMappingURL=AccessTable.context.js.map